<template>
  <div
    v-if="getActiveSite != null"
    id="dashboard"
    class="relative overflow-auto w-screen bg-gray-lightest"
    :class="sectionClass"
  >
    <div class="dashboard-greet-container">
      <DailyGreeting :user="username" />
    </div>
    <div v-if="isChemicalStandalone" class="dashboard-body">
      <ChemicalDashboard />
    </div>
    <div v-else class="dashboard-body">
      <MultiroleDashboard />
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue"
import { mapGetters } from "vuex"
import DailyGreeting from "@/views/Dashboard/components/DailyGreeting.vue"
import LoadingSpinner from "@/components/Loading/LoadingSpinner/LoadingSpinner.vue"

export default {
  name: "DashboardPage",
  components: {
    DailyGreeting,
    MultiroleDashboard: defineAsyncComponent({
      loader: () => import("@/views/Dashboard/Views/MultiroleDashboard.vue"),
      loadingComponent: LoadingSpinner,
    }),
    ChemicalDashboard: defineAsyncComponent({
      loader: () => import("../../Site-Scan/views/ChemicalDashboard.vue"),
      loadingComponent: LoadingSpinner,
    }),
  },
  props: {
    sectionClass: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters([
      "getFullName",
      "getPermissionSetRole",
      "getActiveSite",
      "getPermissionSet"
    ]),
    username() {
      return this.getFullName
    },
    isChemicalStandalone() {
      return this.getPermissionSet.is_chemical_only
    }
  },
};

</script>
<style scoped>
/* Image rendering fix */
img {
  image-rendering: -moz-crisp-edges;         /* Firefox */
  image-rendering:   -o-crisp-edges;         /* Opera */
  image-rendering: -webkit-optimize-contrast;/* Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;  /* IE (non-standard property) */
}

.dashboard-body {
  padding: 1.75rem 1.25rem 2rem;
  max-width: 1536px;
  margin: 0 auto;
}

@media screen and (min-width: 768px) {
  .dashboard-greet-container {
    margin: 0 auto;
    padding: 0 1.25rem;
    max-width: 1536px;
  }
}

@media screen and (min-width: 1024px) {
  .dashboard-body {
    padding: 1.5rem 2rem;
  }
}
@media screen and (max-width: 600px) {
  .dashboard-body {
    padding: 1rem 0.5rem;
  }
}
</style>